import styled from "styled-components";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { calculateTotalPaid, convertCurrency, convertImageToBase64, numberFormat } from "../../helper";
import { S3_URL, USER_KEY } from "../../const";
import { useLazyQuery } from "@apollo/client";
import { GET_SHOP } from "../../apollo/shop/Query";
import { GrCheckboxSelected, GrCheckbox } from "react-icons/gr";
import { GET_EXCHANGRATE } from "../../apollo/exchangeRate/Query";
import { GET_BANKS } from "../../apollo/bank/query";
import { useTranslation } from "react-i18next";
import _ from "lodash";

export default function BillForCheckOut80({
  cartDatas,
  activeCart,
  selectedPayCurrency,
  gencodeordergroup,
  customername,
  phonenumber,
  userconfirmName,
  userconfirmPhone,
  bankaccount,
  customerLastName,
  village,
  district,
  province,
  notYetPaid,
  prepareRate,
  shopData,
  isBillNumber,
  activeTab,
  base64Image,
  change,
  receivedMoney,
  serviceOther
}) {
  const index = cartDatas.findIndex((item) => item?.label === activeCart);
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const user = JSON.parse(localStorage.getItem("USER_DATA"));
  const [code, setCode] = useState();
  const { t } = useTranslation()
  
  const totals = calculateTotalPaid(cartDatas[index]?.data?.orderGroup?.sumPrice, cartDatas[index]?.data?.orderGroup?.currency, prepareRate);
  
  useEffect(() => {
    setCode(gencodeordergroup);
  }, [gencodeordergroup]);

  const orderDate = moment(cartDatas[index]?.data?.orderGroup?.createdAt).isValid()
    ? moment(cartDatas[index]?.data?.orderGroup?.createdAt).format("DD/MM/YYYY HH:mm:ss")
    : moment().format("DD/MM/YYYY HH:mm:ss");


  return (
    <div style={{ padding: 20, width: "100%" }}>

      {base64Image &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={base64Image} alt="avatar-store" style={{ maxWidth: 104, maxHeight: 104, }} />
        </div>
      }

      <div style={{ textAlign: "center", width: "100%" }}>
        <b style={{ fontSize: 17 }}>{shop?.name}</b>
      </div>
      <div style={{ textAlign: "center", width: "100%", fontSize: 12 }}>
        {shop?.address?.village + ", " + shop?.address?.district + ", " + shop?.address?.province}
      </div>
      <div style={{ textAlign: "center", width: "100%", fontSize: 12 }}>
        ໂທ: {shop?.phone ?? "........"}
      </div>
      <div style={{ textAlign: "center", width: "100%" }}>
        <b style={{ fontSize: 16, fontWeight: 'bold' }}>{isBillNumber === "bill_3" ? t("invoice_titleV2") : t("invoice_title")}</b>
      </div>
      <div style={{ textAlign: "left", width: "100%", fontSize: 12 }}>
        {t("number_no")} : {code}
      </div>
      <div style={{ textAlign: "left", width: "100%", fontSize: 12 }}>
        {t("createdBy")} :{" "}
        {user?.data?.nickname ? user?.data?.nickname : user?.data?.firstName + " " + user?.data?.lastName}{" "}
      </div>
      <div style={{ textAlign: "left", width: "100%", fontSize: 12 }}>
        {t("customer_name")}: {customername ?? "........................."} {customerLastName}{" "}
      </div>
      <div style={{ textAlign: "left", width: "100%", fontSize: 12 }}>
        {t("phone_number")}: {phonenumber ?? "............................"}{userconfirmPhone}
      </div>
      {cartDatas[index]?.data?.orderGroup?.addressCf && <div style={{ textAlign: "left", width: "100%", fontSize: 12 }}>
        ຂົນສົ່ງປາຍທາງ: {cartDatas[index]?.data?.orderGroup?.addressCf}
      </div>}
      <div
        style={{
          textAlign: "left",
          width: "100%",
          fontSize: 12,
          borderBottom: "1px solid black",
        }}
      >
        {t("day_month_year")} : {orderDate}
      </div>

      <Order>
        <>
          {cartDatas[index]?.data?.orders?.map((order, index) => (
            <div
              style={{
                lineHeight: 1.3,
              }}
              key={index}
            >
              <div style={{ textAlign: "left", fontSize: 14, display: "flex" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    marginRight: 5,
                  }}
                >
                  {index + 1}{") "}
                </div>
                <div style={{display:"flex",alignItems:"start", flexDirection:"column" }}> 
                  {order?.productName}
                  {order?.survival && shopData?.id==="63ec6d38c617221e6ccf5edc" && <span style={{color:"#a3a3a3ff",fontSize:11}}>ເລກລ໊ອຕ: {order?.survival}</span>}
                </div>
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: 12,
                  paddingLeft: 16,
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 'bold',
                }}
              >
                <p>
                  {" "}
                  {order?.amount} {order?.unit} X{" "}
                  {order?.price ? numberFormat(order?.price) : "-"}{" "}
                  {" " + convertCurrency(order?.currency)} &nbsp; {order?.amountFree && (<>ແຖມ: {order?.amountFree}</>)}
                </p>
                <p>
                  {numberFormat(order?.price * order?.amount)}
                  {" " + convertCurrency(order?.currency)}
                </p>
              </div>
            </div>
          ))}

          {isBillNumber === "bill_1" || isBillNumber === "bill_3" ? (
            <>
              <hr style={{ border: "1px solid #000", marginTop: 10 }} />
              <div style={{ display: "flex", marginTop: '-.2em', justifyContent: "space-between" }}>
                <div style={{ fontSize: 14 }}>{t("totals_name")} </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    fontWeight: 'bold',
                    fontSize: 14
                  }}
                >
                  <span>
                    {numberFormat(cartDatas[index]?.data?.orderGroup?.totalPrice ?? 0)} ₭
                  </span>
                  <span>
                    {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceBaht ?? 0)}{" "}
                    ฿
                  </span>
                  <span>
                    {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceUsd ?? 0)}{" "} $
                  </span>
                </div>
              </div>
              {cartDatas[index]?.data?.orderGroup?.discount > 0 && <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 14 }}>{t("discount_name")} </p>
                <p style={{ fontSize: 14 }}>
                  {cartDatas[index]?.data?.orderGroup?.discount ?? 0}%
                </p>
              </div>}
              {cartDatas[index]?.data?.orderGroup?.taxes && <div style={{ marginTop: -3,display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 14 }}>Tax</p>
                <p style={{ fontSize: 14 }}>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.taxes?.tax ?? 0)} {cartDatas[index]?.data?.orderGroup?.taxes?.taxType === "PERCENT" ? "%" : "₭"}
                </p>
              </div>}
              {cartDatas[index]?.data?.orderGroup?.shippingCost > 0 && <div style={{ marginTop: -10,display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 14 }}>{cartDatas[index]?.data?.orderGroup?.costTitle}</p>
                <p style={{ fontSize: 14 }}>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.shippingCost ?? 0)}₭
                </p>
              </div>}
            

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 16, fontWeight: 'bold' }}>{t("sum_amount")} :</p>
                <p style={{ fontSize: 16, fontWeight: 'bold' }}>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPrice ?? 0)} {convertCurrency(selectedPayCurrency)}
                </p>
              </div>

            </>
          ) : (
            <>

              <div style={{ display: "flex", justifyContent: "space-between", borderTop: '1px solid gray', marginTop: 10, paddingTop: 5 }}>
                <p style={{ fontSize: 11, fontWeight: "300" }}>ເປັນເງິນບາດ</p>
                <p style={{ fontSize: 11, fontWeight: "300" }}> {numberFormat(totals?.totalBaht ?? 0)}{" "} ບາດ</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: -3 }}>
                <p style={{ fontSize: 11, fontWeight: "300" }}>ເປັນເງິນໂດລາ</p>
                <p style={{ fontSize: 11, fontWeight: "300" }}> {numberFormat(totals?.totalUsd ?? 0)} ໂດລາ</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: -3 }}>
                <p style={{ fontSize: 14, fontWeight: "bold" }}>ເປັນເງິນກີບ</p>
                <p style={{ fontSize: 14, fontWeight: "bold" }}>
                  {numberFormat(totals?.totalKip ?? 0)} ກີບ
                </p>
              </div>
            </>
          )}

          <div
            style={{
              fontSize: 12,
              display: "flex",
              width: "100%",
              borderTop: '1px solid gray',
              justifyContent: "center",
              flexDirection: "column",
              marginBottom: 20
            }}
          ></div>
          <div
            style={{
              fontSize: 12,
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            {!notYetPaid ? (
              <div className="d-flex gap-2 flex-column">
                <div>
                  <GrCheckboxSelected /> {t("is_pay")}{" "}
                </div>
                <div style={{ marginTop: -5 }}>
                  <GrCheckbox /> {t("not_pay")}{" "}
                </div>
              </div>
            ) : (
              <div className="d-flex gap-2 flex-column">
                <div>
                  <GrCheckbox /> {t("is_pay")}{" "}
                </div>
                <div style={{ marginTop: -5 }}>
                  <GrCheckboxSelected /> {t("not_pay")}{" "}
                </div>
              </div>
            )}
            <p style={{ fontSize: 12 }}>
              {activeTab === "CASH"
                ? t("cash_money_name")
                : t("transfer_money_name")}
            </p>
          </div>

        </>
      </Order>


      <p style={{ fontSize: 12, marginTop: 2, textAlign: 'center', width: '100%' }}>{shopData?.descriptionPOSBill ?? "ຂອບໃຈລູກຄ້າທີ່ມາໃຊ້ບໍລິການ"}</p>
      <p style={{ fontSize: 12 }}>ເງິນທີ່ໄດ້ຮັບມາ {numberFormat(receivedMoney ?? 0)} ກີບ, ຄ່າເຄື່ອງ  {numberFormat(totals?.totalKip ?? 0)} ກີບ, ເງິນທີ່ຕ້ອງຖອນກັບຄືນ {numberFormat(change ?? 0)} ກີບ</p>
      {!_.isEmpty(cartDatas[index]?.data?.orderGroup?.note) && <p style={{ fontSize: 12, marginTop: -15 }}>[ໝາຍເຫດ]: {cartDatas[index]?.data?.orderGroup?.note}</p>}
    </div>
  );

}

const Order = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
